















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { RecommendItem } from '../../modules/silverEgg/RecommendResponse'

@Component({})
export default class RecommendProduct extends Vue {
  @Prop() private recommendItems!: RecommendItem[]

  private mounted() {
    window.initSwiper()
  }

  /**
   * 製品クリック処理
   */
  private select(item: RecommendItem) {
    this.$emit('select', item, 'product')
  }
}
